import { Component, OnChanges, OnInit, Output, SimpleChanges,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CargarScriptsService } from 'src/app/cargar-scripts.service';


@Component({
  selector: 'app-navbaresp',
  templateUrl: './navbaresp.component.html',
  styleUrls: ['./navbaresp.component.css']
})
export class NavbarespComponent implements OnInit, OnChanges {
  constructor( private _CargaScripts:CargarScriptsService,
    private route:ActivatedRoute
    ) 
  {
    _CargaScripts.Carga(["navbar"]);
    this.cart = this.getCart()
    this.number = this.cart.length

    
   }
  
  @Input() number = 0;
  cart: any;
  display = false;
  public activePage = location.href;
  

  public pages = [
    {
      name:'Biografía',
      path: '#/es/biografia'
    },
    {
      name: 'Catálogo',
      path: '#/es/catalogo'
    },
    {
      name:'Contacto',
      path: '#/es/contacto'
    }
  ]
  
  changeValue(boolean){
    this.display = boolean
  }
  
  changeNumber($event){
    this.number = $event;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cart = this.getCart()
    this.number = this.cart.length
    changes.cart
    changes.number
    
  }

  ngOnInit(): void {
    
  }

  getCart(){
    return localStorage.getItem("cart")
    ? JSON.parse(localStorage.getItem("cart"))
    : [];
  }

  abrirCart(){
    this.display = !this.display;
    this.cart = this.getCart();
    this.number = this.cart.length
    
  }
}
